import { render, staticRenderFns } from "./InvitationPreview.vue?vue&type=template&id=5476ba1f&"
import script from "./InvitationPreview.vue?vue&type=script&lang=js&"
export * from "./InvitationPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports